import { Select, Spin } from "antd";
import React, { memo, useCallback, useState } from "react";
import { apiDriver } from "../../../../api/api-driver";

const { Option } = Select;

const TaiXe = ({ setFieldsValue, name }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUser = (value) => {
    setLoading(true);

    const filter = {
      // birthdate: null,
      // id_card: null,
      // mobile_full: null,
      name: `%${value.trim().replace(/%/gi, "\\%")}%`,
      // status: null,
      // user_group: { id: null },
    };

    apiDriver
      .getDrivers(filter, 1)
      .then((res) => {
        if (res.status === "success") {
          setOptions(
            res.data.content.map((i) => ({ value: i.id, label: i.name }))
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const onChange = useCallback((values) => {
    !!setFieldsValue &&
      setFieldsValue({
        [name]: {
          id_in: values.length > 0 ? values.map((i) => i.value) : null,
        },
      });
  }, []);

  return (
    <Select
      mode="multiple"
      showArrow
      placeholder="Tài xế"
      labelInValue
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onChange={onChange}
      onSearch={fetchUser}
    >
      {options.map((item, index) => (
        <Option key={index} value={item.value}>
          {item.label}
        </Option>
      ))}
    </Select>
  );
};

export default memo(TaiXe);
